// npx ng build --configuration=production

export const environment = {
  title: 'Lake Flood Elevation Online',
  production: true,
  version: "Development Version: 2.5, Build Date: 05/18/2026",
  application_contact: 'jeremy.moore@state.mn.us',

  // Azure Functions
  portalTokenUrl: 'https://r29p-gis-portal-oauth-func-001.azurewebsites.net/api/getToken?app_id=mntopo',

  // Portal + Web Maps
  portalURL: 'https://gis.dnr.state.mn.us/arcgis',
  editorWebMap: '20d1da307f214adbbeae72808f95b7c2',
  publicWebMap: '2406756e176e4d12a05579169ea3ce1e',
  appID: 'c07up1IxIP6a0xLC',
  // appName: 'Lakefloodplain', 

  // FeatureServer tables
  studiesTableUrl: 'https://gis.dnr.state.mn.us/appserver/rest/services/ewr/app_lake_floodplain_table_editor/FeatureServer/0',
  elevationsTableUrl: 'https://gis.dnr.state.mn.us/appserver/rest/services/ewr/app_lake_floodplain_table_editor/FeatureServer/1',
  basinsLayerUrl: 'https://gis.dnr.state.mn.us/host/rest/services/Hosted/DNR_Public_Waters_Delineations/FeatureServer/1', 
  basinFloodUrl: 'https://gis.dnr.state.mn.us/appserver/rest/services/ewr/app_lake_flood_elevations/MapServer/0',

  // GP print services
  printMapReportUrl: 'https://gis.dnr.state.mn.us/appserver/rest/services/appUtilities/LFEOWebMapExport/GPServer/Export%20Web%20Map',
  printBasinReportUrl: 'https://gis.dnr.state.mn.us/appserver/rest/services/appUtilities/LFEObasinOnlyReport/GPServer/Export%20Web%20Map',

  // Utility services
  dnrSearch: 'https://gis.dnr.state.mn.us/appserver/rest/services/gen/dnr_search/MapServer/0',

  // App Insights
//  appInsightsConfig: {
//     instrumentationKey: '95c01ee6-46e6-41f6-a7f0-4465a4d07601',
//   },
};
